const React = require('react');
const ConfigCard = require('../../../ConfigCard');
const {AdminSelect} = require("../../../../../../FormInputs");
const {CURRENCIES_LIST} = require("../../../../../../../../constants/currencies");

module.exports = ({formCtx, disabled}) => {
  return (
    <ConfigCard className="layoutRow jcSB aiC mt24">
      <div className="w layoutRow jcSB aiC dB@m2">
        <div className="f12 lh18 fw7">
          BASE TRANSACTION CURRENCY
        </div>
        <div className="wmax200 w (mt-10|mb-18)>.MuiFormControl-root (mt10)>.MuiFormControl-root@m2">
          <AdminSelect
            name="fiat_code"
            items={CURRENCIES_LIST}
            formCtx={formCtx}
            disableLabel
            disabled={disabled}
          />
        </div>
      </div>
    </ConfigCard>
  )
}
